import ACTIONS from 'application/constants'

export const openContactInfoPopupSidebar = (payload) => ({
    type: ACTIONS.SIDEBAR_OPEN_CONTACT_INFO,
    payload
})

export const closeContactInfoPopupSidebar = () => ({
    type: ACTIONS.SIDEBAR_CLOSE_CONTACT_INFO
})